import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Header, Segment, Button, GridColumn, Grid, GridRow } from 'semantic-ui-react';
import LabBrowser from "../components/LabBrowser";
import LabCatalog from "../components/LabCatalog";
import { useTranslation } from 'react-i18next';
import EmployeeResources from "../components/EmployeeResources";
import { useDemoContext } from "../DemoContext";
import { Container } from "@mui/material";
import Loader from "../components/Loader";
import { useFlags } from "flagsmith/react";

const Home = () => {
    const { t } = useTranslation();
    const flags = useFlags(['event_management']);
    const demoContext = useDemoContext()
    const {
        isAuthenticated,
        loginWithRedirect,
    } = useAuth0();

    return (
        <Container maxWidth='lg' sx={{marginBottom: '3.42857143rem'}}>
            {isAuthenticated ? (
                <Container className='AppContent'>
                    {demoContext.isReady ? (
                        <>
                            <LabBrowser />
                            <LabCatalog />
                            {!flags.event_management?.enabled && <EmployeeResources />}
                        </>
                    )
                        : (<Loader/>)
                    }

                </Container>
            ) : (
                <Container className='AppContent' maxWidth='lg'>
                    <Segment basic>
                       
                        <Grid relaxed>
                            <GridColumn verticalAlign="middle" computer={8} mobile={16}>
                                <GridRow>
                                    <Header as="h2" size="large" className='brandMessage'>
                                        {t('landing-banner')}
                                    </Header>
                                    <div>
                                        <Button className="secondaryCtaButton ctaButton"onClick={loginWithRedirect}>{t('getStarted')}</Button>
                                        <Button className="secondaryCtaButtonOutline ctaButton"onClick={()=>{window.open("https://www.okta.com/resources/events/")}}>{t('findEvent')}</Button>
                                    </div>
                                </GridRow>
                            </GridColumn>
                            <GridColumn computer={8} className="promoImageContainer" only="computer">
                            <img className='promoImage' src="https://cdn.demo.okta.com/images/okta-stock/lab.jpg" alt="Okta hands on labs" />
                            </GridColumn>
                        </Grid>

                    </Segment>

                    <Segment basic>
                        <div className="promoCopy">
                        {t('landing-promoCopy')}
                            </div>
                            <div className="promoCopy">
                        {t('landing-body')}
                        </div>
                    </Segment>

                    <Segment basic>
                        <Header as="h2" size="large" className='brandMessage'>
                        {t('certifiedTraining')}
                        </Header>
                        {t('certifiedTrainingCopy')}
                        <Segment basic><a className="brandColor" href="https://www.okta.com/services/training/#browse" target="_blank" rel="noopener noreferrer">{t('certifiedTrainingCatalogCTA')}</a></Segment>
                    </Segment>
                    <Segment basic>
                        <Header as="h2" size="large" className='brandMessage'>
                            {t('Certification')}
                        </Header>
                        <div>{t('certificationCopy')}</div>
                        <div><Button className="secondaryCtaButton ctaButton"onClick={()=>{window.open("https://www.okta.com/services/certification/")}}>{t('certificationCTA')}</Button></div>
                    </Segment>
                </Container>
            )}
        </Container>
    )
}
export default Home;